import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';
import { OnlyFansPayout } from './useMetricsDailyStats';

const useMetricsDailyStatsEarningsAllWeek = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const params = useParams();
    const axios = useAxios();

    // Fetch
    const fetchData = async (): Promise<{ _id: Date; earnings?: OnlyFansPayout.All }[]> => {
        const query: string = `${settingsContext.routes.metrics.base}${params.userId}/earningsAll/week`;

        const data = await axios
            .get(query)
            .then(async response => response.data)
            .catch(error => {
                console.error('Error fetching metrics daily stats earnings all week:', error);

                return [];
            });

        return data;
    };

    return useQuery(
        ['metricsDailyStatsEarningsAllWeek', params.userId],
        () => {
            return fetchData();
        },
        {
            refetchOnWindowFocus: false,
            // Stale time 1 hour
            staleTime: 60 * 60 * 1000,
            enabled: userContext.jwtToken && settingsContext.apiKey && params.userId ? true : false,
        },
    );
};

export default useMetricsDailyStatsEarningsAllWeek;
